module.exports = __webpack_public_path__ + "img/FR18359.1ffb4379.svg";